module.exports = __webpack_public_path__ + "img/meditation.8d5f0f52.svg";